<template>
 <div class="nav-wrapper">
  <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title">{{ $t('saveProgress.title') }}</h1>
        <p class="subtitle">{{ $t('saveProgress.subtitle') }}</p>

        <div class="contact-form">
          <div class="form-row">
            <div class="form-group">
              <label class="required">{{ $t('saveProgress.form.firstName.label') }}</label>
              <input type="text" v-model="contactInfo.firstName" :placeholder="$t('saveProgress.form.firstName.placeholder')"
                class="form-input" :class="{ 'error': errors.firstName }" />
              <span class="error-message" v-if="errors.firstName">{{ $t(errors.firstName) }}</span>
            </div>

            <div class="form-group">
              <label class="required">{{ $t('saveProgress.form.lastName.label') }}</label>
              <input type="text" v-model="contactInfo.lastName" :placeholder="$t('saveProgress.form.lastName.placeholder')" 
                class="form-input" :class="{ 'error': errors.lastName }" />
              <span class="error-message" v-if="errors.lastName">{{ $t(errors.lastName) }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="required">{{ $t('saveProgress.form.email.label') }}</label>
              <input type="email" v-model="contactInfo.email" :placeholder="$t('saveProgress.form.email.placeholder')"
                class="form-input" :class="{ 'error': errors.email }" />
              <span class="error-message" v-if="errors.email">{{ $t(errors.email) }}</span>
            </div>

            <div class="form-group">
              <label class="required">{{ $t('saveProgress.form.phone.label') }}</label>
              <input type="tel" v-model="contactInfo.phone" :placeholder="$t('saveProgress.form.phone.placeholder')" 
                class="form-input" :class="{ 'error': errors.phone }" />
              <span class="error-message" v-if="errors.phone">{{ $t(errors.phone) }}</span>
            </div>
          </div>

          <div class="address-fields">
            <h4 class="section-title">Address Information</h4>
            <div class="form-row">
              <div class="form-group">
                <label class="required">Street Address</label>
                <input type="text" v-model="contactInfo.homeStreet" placeholder="Enter street address" 
                  class="form-input" :class="{ 'error': errors.homeStreet }" />
                <span class="error-message" v-if="errors.homeStreet">{{ errors.homeStreet }}</span>
              </div>
              <div class="form-group">
                <label class="required">City</label>
                <input type="text" v-model="contactInfo.homeCity" placeholder="Enter city" 
                  class="form-input" :class="{ 'error': errors.homeCity }" />
                <span class="error-message" v-if="errors.homeCity">{{ errors.homeCity }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="required">State</label>
                <input type="text" v-model="contactInfo.homeState" placeholder="Enter state" 
                  class="form-input" :class="{ 'error': errors.homeState }" />
                <span class="error-message" v-if="errors.homeState">{{ errors.homeState }}</span>
              </div>
              <div class="form-group">
                <label class="required">ZIP Code</label>
                <input type="text" v-model="contactInfo.homeZip" placeholder="Enter ZIP code" 
                  class="form-input" :class="{ 'error': errors.homeZip }" />
                <span class="error-message" v-if="errors.homeZip">{{ errors.homeZip }}</span>
              </div>
            </div>
          </div>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('saveProgress.next') }}</button>
      </div>
    </div>
    <div class="image-section">
      <img src="@/assets/background.jpeg" alt="Primary Contact Illustration" class="main-image">
    </div>
  </div>
 </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'SaveProgress',
  components: {
    BackButton
  },
  data() {
    return {
      contactInfo: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        homeStreet: '',
        homeCity: '',
        homeState: '',
        homeZip: ''
      },
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        homeStreet: '',
        homeCity: '',
        homeState: '',
        homeZip: '',
        general: ''
      }
    }
  },
  computed: {
    formSectionPadding() {
      return this.windowWidth <= 800 ? '80px' : '180px'
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    validateForm() {
      this.errors = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        homeStreet: '',
        homeCity: '',
        homeState: '',
        homeZip: '',
        general: ''
      };
      
      let isValid = true;

      // First Name validation
      if (!this.contactInfo.firstName.trim()) {
        this.errors.firstName = 'saveProgress.form.firstName.errors.required';
        isValid = false;
      } else if (this.contactInfo.firstName.trim().length < 2) {
        this.errors.firstName = 'saveProgress.form.firstName.errors.minLength';
        isValid = false;
      }

      // Last Name validation
      if (!this.contactInfo.lastName.trim()) {
        this.errors.lastName = 'saveProgress.form.lastName.errors.required';
        isValid = false;
      } else if (this.contactInfo.lastName.trim().length < 2) {
        this.errors.lastName = 'saveProgress.form.lastName.errors.minLength';
        isValid = false;
      }

      // Email validation
      if (!this.contactInfo.email.trim()) {
        this.errors.email = 'saveProgress.form.email.errors.required';
        isValid = false;
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.contactInfo.email)) {
          this.errors.email = 'saveProgress.form.email.errors.format';
          isValid = false;
        }
      }

      // Phone validation
      if (!this.contactInfo.phone.trim()) {
        this.errors.phone = 'saveProgress.form.phone.errors.required';
        isValid = false;
      } else {
        const phoneRegex = /^\+?[\d\s-()]{10,}$/;
        if (!phoneRegex.test(this.contactInfo.phone)) {
          this.errors.phone = 'saveProgress.form.phone.errors.format';
          isValid = false;
        }
      }

      // Address validation
      if (!this.contactInfo.homeStreet.trim()) {
        this.errors.homeStreet = 'Street address is required';
        isValid = false;
      }
      if (!this.contactInfo.homeCity.trim()) {
        this.errors.homeCity = 'City is required';
        isValid = false;
      }
      if (!this.contactInfo.homeState.trim()) {
        this.errors.homeState = 'State is required';
        isValid = false;
      }
      if (!this.contactInfo.homeZip.trim()) {
        this.errors.homeZip = 'ZIP code is required';
        isValid = false;
      }

      return isValid;
    },
    async handleNext() {
      if (this.validateForm()) {
        try {
          // Format phone number to ensure consistent format
          const formattedPhone = this.contactInfo.phone.replace(/[^\d]/g, '');
          const formattedPhoneWithPlus = formattedPhone.length === 10 ? 
            `+1${formattedPhone}` : 
            `+${formattedPhone}`;
          
          // Prepare owner details with proper validation
          const ownerDetails = {
            firstName: this.contactInfo.firstName.trim(),
            lastName: this.contactInfo.lastName.trim(),
            email: this.contactInfo.email.trim().toLowerCase(),
            phone: formattedPhoneWithPlus,
            role: 'BusinessOwner',
            status: 'Active'
          };

          // Prepare address data with proper validation
          const ownerAddress = {
            streetAddress: this.contactInfo.homeStreet.trim(),
            city: this.contactInfo.homeCity.trim(),
            state: this.contactInfo.homeState.trim(),
            zipCode: this.contactInfo.homeZip.trim(),
            addressType: 'Owner',
            isDefault: true
          };

          // Store the data temporarily
          this.$emit('next', {
            ownerDetails,
            ownerAddress,
            saveProgress: true
          });

        } catch (error) {
          console.error('Error preparing data:', error);
          this.errors.general = 'Failed to prepare data. Please try again.';
        }
      }
    },
    handleSkip() {
      this.$emit('next', {
        ownerDetails: null,
        ownerAddress: null,
        saveProgress: true
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
.experience-container {
  max-width: var(--breakpoint-xl);
  margin: var(--spacing-xl) auto 0;
  padding: 0 var(--spacing-md);
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: stretch;
  min-height: 100vh;

  height: 600px;
}
.form-section, .image-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative; /* Add position relative for proper containment */
}

.image-section {
  padding: 0; /* Remove any padding that might create space */
  margin-top: 60px; /* Remove any margin that might create space */
  overflow: hidden; /* Prevent image overflow */
}

.image-section img.main-image {
  width: 100%;
  height: 100%; /* Make image fill the container height */
  object-fit: cover;
  display: block; /* Remove any default spacing from inline elements */
  position: absolute; /* Position absolutely within the container */
  top: 0; /* Align to the top */
  left: 0;
}

.business-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem; /* Add padding to the form instead of the section */
}
</style> 